import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { AdvisorChartWithMetrics, CHART_TYPES } from '@bingads-webui-campaign-react/advisor-chart';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/dashboard-cards');

export class CompetitionTile extends React.PureComponent {
  static defaultProps = {
    domains: null,
  };

  static propTypes = {
    chartData: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      items: PropTypes.array.isRequired,
    }).isRequired,
    domains: PropTypes.arrayOf(PropTypes.string),
    metric: PropTypes.string.isRequired,
    chartType: PropTypes.oneOf(_.values(CHART_TYPES)).isRequired,
  };

  render() {
    const { totalCount, items } = this.props.chartData;
    if (totalCount > 0) {
      return (
        <div>
          <div className="row">
            <div className="chart-container col-sm-12">
              <AdvisorChartWithMetrics
                i18n={i18n}
                selectedMetric={this.props.metric}
                domains={this.props.domains}
                chartType={this.props.chartType}
                items={items}
              />
            </div>
          </div>
        </div>
      );
    }
    return (null);
  }
}

